module.exports = __webpack_public_path__ + "static/ag-grid-ee5814238b388d01a44a5f221badc648.svg";